/**
 * Video play icon
 */
$('.video-framewrapper .section-title .preholder-image .play-button').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.preholder-image').fadeOut();
    $('#header_video').show();
    $('#header_video')[0].src += "?autoplay=1";
});

/**
 * Sticky shop button
 */
window.onscroll = function() {stickyFunction()};

var header = document.querySelector(".sticky-shop-button-bar");
var sticky = header.offsetTop + 55;

function stickyFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}